const ServiceActionLabels = {
  edit: "SERVICE_ACTIONS.EDIT",
  delete: "SERVICE_ACTIONS.DELETE",
  restart: "SERVICE_ACTIONS.RESTART",
  resume: "SERVICE_ACTIONS.RESUME",
  open: "SERVICE_ACTIONS.OPEN_SERVICE",
  scale: "SERVICE_ACTIONS.SCALE",
  scale_by: "SERVICE_ACTIONS.SCALE_BY",
  suspend: "SERVICE_ACTIONS.SUSPEND"
};

module.exports = ServiceActionLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceActionLabels.js